<template>
  <v-layout>
    <v-dialog v-if="product_type == null" :modelValue="dialog" @click:outside="close()" @keydown.esc="close()" fullscreen
      transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <span class="headline">Importar Producto</span>
        </v-card-title>

        <v-card-text style="margin-bottom: 80px;">
          <v-row align="center" justify="center" class="mb-4 mt-4">
            <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
              <a-steps :current="0">
                <a-step title="Tipo de Producto" />
                <a-step title="Importar Excel" />
                <a-step title="Detalle del Excel" />
              </a-steps>
            </v-col>
          </v-row>

          <v-row align="start" justify="center">
            <v-col md="6" class="mt-4 pr-0 pl-0">
              <div class="px-2 py-1 mb-3 bg-subtitle-section">
                <p class="text-subtitle-1 mb-0">
                  <b>Tipo de Producto</b>
                </p>
              </div>
              <p class="mb-2">¿Qué tipo de producto desea importar?</p>
              <v-radio-group v-model="selected_type">
                <v-radio style="margin-top: 10px" label="Producto" value="product"></v-radio>
                <v-radio style="margin-top: 10px" label="Producto Combo" value="combo"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0;">
          <v-row align="start" justify="center">
            <v-col cols="10" style="background-color: white;">
              <v-btn class="float-right" variant="outlined" color="primary" :disabled="selected_type == null"
                @click="proceed">Siguiente</v-btn>
            </v-col>
            <v-col cols="12" style="background-color: #fafafa;border-top: 1px solid #c1c1c1;" class="text-end">
              <v-btn color="error" text @click="close()">Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalImportExcel v-if="product_type == 'product'" :dialog="true" button_name="Importar Producto"
      modal_title="Producto" :page_title="page_title" formBtn="Importar" :service="service" :back_button="true"
      @updateDialog="onChildUpdateDialog" @back="goBackToTypeSelection" @loadList="$emit('loadList')" />

    <ModalImportComboExcel v-if="product_type == 'combo'" :dialog="true" button_name="Importar Producto Combo"
      modal_title="Producto Combo" :page_title="page_title" formBtn="Importar" :service="service" :back_button="true"
      @updateDialog="onChildUpdateDialog" @back="goBackToTypeSelection" @loadList="$emit('loadList')" />
  </v-layout>
</template>

<script>
import ModalImportExcel from "./ModalImportExcel.vue";
import ModalImportComboExcel from "./ModalImportComboExcel.vue";

export default {
  components: { ModalImportExcel, ModalImportComboExcel },
  props: {
    service: Object,
    page_title: String,
    dialog: Boolean,
  },
  data() {
    return {
      selected_type: null,
      product_type: null,
    };
  },
  watch: {
    dialog(value) {
      if (value) {
        this.selected_type = null;
        this.product_type = null;
      }
    },
  },
  methods: {
    proceed() {
      this.product_type = this.selected_type;
    },
    onChildUpdateDialog(value) {
      if (!value) {
        this.selected_type = null;
        this.product_type = null;
        this.$emit("updateDialog", false);
      }
    },
    goBackToTypeSelection() {
      this.product_type = null;
    },
    close() {
      this.selected_type = null;
      this.product_type = null;
      this.$emit("updateDialog", false);
    },
  },
};
</script>
